import React from 'react';
import { BreadcrumbNavigation, BreadcrumbItem } from '@entur/menu';
import { Link } from 'gatsby';
import { useLocation } from '@reach/router';
import { useIntl } from 'react-intl';
import './Breadcrumbs.scss';
import * as ROUTES from '~/lib/routes';

export const Breadcrumbs = () => {
  const location = useLocation();
  const { formatMessage: f } = useIntl();
  const crumbs = getCrumbs(location.pathname);

  return (
    <>
      {crumbs && (
        <BreadcrumbNavigation>
          {crumbs.map((item) => (
            <BreadcrumbItem as={Link} to={item.url} key={item.url}>
              {f({ id: item.name })}
            </BreadcrumbItem>
          ))}
        </BreadcrumbNavigation>
      )}
    </>
  );
};

function getCrumbs(path: string): { name: string; url: string }[] | null {
  const paths = path.split('/').filter((entry) => entry !== '');

  const crumbs: { name: string; url: string }[] = [
    { name: 'breadcrumb.hjem', url: 'https://entur.no/' },
  ];

  if (paths.length < 1) return null;

  let currentPath = '';

  paths.forEach((path) => {
    currentPath += `/${path}`;
    const foundCrumb = Object.values(ROUTES).find(
      (element) => currentPath === element.url
    );
    if (foundCrumb) {
      crumbs.push(foundCrumb);
    }
  });

  return crumbs;
}
